<template>
  <!-- HEADER -->
  <div class="header">
    <div class="container-fluid">
      <!-- Body -->
      <!-- / .row -->

      <!-- Filter -->
      <!-- end of filter -->

      <!-- Table -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Role Competency</h4>
          <!-- Add Button -->
          <div class="card-header-action">
            <b-button
              v-if="listTabMenu.privilages && listTabMenu.privilages.create"
              class="btn-pill"
              variant="primary"
              @click="addData()">
              <span class="fe fe-file-plus"></span>
              Add Role
            </b-button>
          </div>
        </div>
        <vue-good-table
          :line-numbers="false"
          :columns="columns"
          :rows="roleCompetencyData"
          :sort-options="{
            enabled: true
          }"
          :total-rows="totalItems"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            position: 'bottom',
            perPage: body.limit,
            perPageDropdown: [10, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: body.page,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All'
          }"
          style-class="vgt-table border-0 table"
          @on-page-change="onPageChange"
          @on-per-page-change="onPageChange">
          <!-- Loading -->
          <div slot="emptystate" class="text-center font-size-14">
            {{ isLoading ? 'Loading...' : 'No data available' }}
          </div>

          <!-- Custom Rows -->
          <template slot="table-row" slot-scope="props">
            <!-- No Column -->
            <span v-if="props.column.field == 'no'">
              {{ (body.page - 1) * body.limit + props.index + 1 }}
            </span>

            <!-- ID -->
            <span v-if="props.column.field == 'id'">
              {{ props.row.id }}
            </span>

            <!-- Role Competency ID -->
            <span v-if="props.column.field == 'role_competency_id'">
              {{ props.row.role_competency_id }}
            </span>

            <!-- Role Competency Name -->
            <span v-if="props.column.field == 'role_competency_name'">
              {{ props.row.role_competency_name }}
            </span>

            <!-- Role Competency Type -->
            <span v-if="props.column.field == 'role_competency_type'">
              <span class="badge badge-pill" :class="getTypeClass(props.row.role_competency_type)">
                {{ props.row.role_competency_type }}
              </span>
            </span>

            <!-- Table Action -->
            <span v-if="props.column.field == 'action'">
              <b-button
                v-if="listTabMenu.privilages && listTabMenu.privilages.read"
                class="no-wrap btn-pill me-2"
                variant="info"
                size="sm"
                @click="viewData(props.row)">
                <span class="fe fe-eye"></span>
              </b-button>
              <b-button
                v-if="listTabMenu.privilages && listTabMenu.privilages.update"
                class="no-wrap btn-pill me-2"
                variant="warning"
                size="sm"
                @click="updateData(props.row)">
                <span class="fe fe-edit"></span>
              </b-button>
              <b-button
                v-if="listTabMenu.privilages && listTabMenu.privilages.delete"
                class="no-wrap btn-pill"
                variant="danger"
                size="sm"
                @click="deleteData(props.row.id)">
                <span class="fe fe-trash"></span>
              </b-button>
            </span>
          </template>
        </vue-good-table>
      </div>

      <!-- Modal -->
      <b-modal 
        id="modal-role-competency" 
        centered 
        hide-footer 
        :title="modalTitle"
        size="lg">
        <!-- Add Form -->
        <form @submit.prevent="saveAdd()" v-if="isAdd === true">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>ID <span class="text-danger">*</span></label>
                <input
                  v-validate="'required'"
                  name="Role Competency ID"
                  type="text"
                  v-model="bodyAdd.role_competency_id"
                  class="form-control"
                  placeholder="Enter ID" />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Role Competency ID')"
                  >{{ errors.first("Role Competency ID") }}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Role Name <span class="text-danger">*</span></label>
                <input
                  v-validate="'required'"
                  name="Role Name"
                  type="text"
                  v-model="bodyAdd.role_competency_name"
                  class="form-control"
                  placeholder="Role Name" />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Role Name')"
                  >{{ errors.first("Role Name") }}</span>
              </div>
            </div>
            <!-- <div class="col-md-12">
              <div class="form-group">
                <label>Type <span class="text-danger">*</span></label>
                <select
                  v-validate="'required'"
                  name="Role Competency Type"
                  v-model="bodyAdd.role_competency_type"
                  class="form-control">
                  <option value="">Select Type</option>
                  <option value="Internal">Internal</option>
                  <option value="External">External</option>
                  <option value="Tematik">Tematik</option>
                </select>
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Role Competency Type')"
                  >{{ errors.first("Role Competency Type") }}</span>
              </div>
            </div> -->
          </div>
          <div class="form-group text-right">
            <button
              type="button"
              class="btn btn-secondary me-2"
              @click="$bvModal.hide('modal-role-competency')">
              Cancel
            </button>
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="isLoading">
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"></span>
              {{ isLoading ? 'Saving...' : 'Save' }}
            </button>
          </div>
        </form>

        <!-- Edit Form -->
        <form @submit.prevent="saveUpdate()" v-else-if="isAdd === false">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>ID <span class="text-danger">*</span></label>
                <input
                  v-validate="'required'"
                  name="Role Competency ID"
                  type="text"
                  v-model="bodyUpdate.role_competency_id"
                  class="form-control"
                  placeholder="ID" />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Role Competency ID')"
                  >{{ errors.first("Role Competency ID") }}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Role Name <span class="text-danger">*</span></label>
                <input
                  v-validate="'required'"
                  name="Role Name"
                  type="text"
                  v-model="bodyUpdate.role_competency_name"
                  class="form-control"
                  placeholder="Role Name" />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Role Competency Name')"
                  >{{ errors.first("Role Competency Name") }}</span>
              </div>
            </div>
            <!-- <div class="col-md-12">
              <div class="form-group">
                <label>Type <span class="text-danger">*</span></label>
                <select
                  v-validate="'required'"
                  name="Role Competency Type"
                  v-model="bodyUpdate.role_competency_type"
                  class="form-control">
                  <option value="">Select Type</option>
                  <option value="Internal">Internal</option>
                  <option value="External">External</option>
                  <option value="Tematik">Tematik</option>
                </select>
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Role Competency Type')"
                  >{{ errors.first("Role Competency Type") }}</span>
              </div>
            </div> -->
          </div>
          <div class="form-group text-right">
            <button
              type="button"
              class="btn btn-secondary me-2"
              @click="$bvModal.hide('modal-role-competency')">
              Cancel
            </button>
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="isLoading">
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"></span>
              {{ isLoading ? 'Updating...' : 'Update' }}
            </button>
          </div>
        </form>

        <!-- View Mode -->
        <div v-else>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label><strong>ID:</strong></label>
                <p>{{ viewDetailData.role_competency_id }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label><strong>Role Name:</strong></label>
                <p>{{ viewDetailData.role_competency_name }}</p>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label><strong>Type:</strong></label>
                <p>
                  <span class="badge badge-pill" :class="getTypeClass(viewDetailData.role_competency_type)">
                    {{ viewDetailData.role_competency_type }}
                  </span>
                </p>
              </div>
            </div>
          </div> -->
          <div class="form-group text-right">
            <button
              type="button"
              class="btn btn-secondary"
              @click="$bvModal.hide('modal-role-competency')">
              Close
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { formatDate, formatDateForInput } from '@/utils/dateFormatter';

export default {
  name: "RoleCompetency",
  computed: {
    roleCompetencyData() {
      return this.$store.getters["roleCompetency/getRoleCompetencies"] || [];
    },
    totalItems() {
      return this.$store.getters["roleCompetency/getTotalItems"] || 0;
    },
    isLoading() {
      return this.$store.getters["roleCompetency/getLoading"];
    }
  },
  data() {
    return {
      listTabMenu: {
        privilages: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      },
      body: {
        page: 1,
        limit: 10,
        search: "",
        order: ""
      },
      bodyAdd: {
        role_competency_id: "",
        role_competency_name: "",
        role_competency_type: ""
      },
      bodyUpdate: {
        id: "",
        role_competency_id: "",
        role_competency_name: "",
        role_competency_type: ""
      },
      viewDetailData: {},
      isAdd: true,
      modalTitle: "Add Role Competency",
      columns: [
        {
          label: "NO",
          field: "no",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "5%",
          sortable: false
        },
        {
          label: "ID",
          field: "role_competency_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "15%"
        },
        {
          label: "Role Name",
          field: "role_competency_name",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "55%"
        },
        // {
        //   label: "Type",
        //   field: "role_competency_type",
        //   thClass: "table-header text-muted font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        //   width: "25%"
        // },
        {
          label: "ACTION",
          field: "action",
          thClass: "table-header no-wrap text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle",
          width: "20%"
        }
      ]
    };
  },
  mounted() {
    this.getRoleCompetencies();
    this.setMenuPermissions();
  },
  methods: {
    // Imported utility functions
    formatDate,
    formatDateForInput,

    // Get CSS class for type badge
    getTypeClass(type) {
      switch(type) {
        case 'Internal':
          return 'badge-success';
        case 'External':
          return 'badge-primary';
        case 'Tematik':
          return 'badge-warning';
        default:
          return 'badge-secondary';
      }
    },

    // Set menu permissions
    setMenuPermissions() {
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || '[]');
      const currentPath = window.location.pathname;
      const menu = listMenu.find((menu) =>
        menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
      );
      this.listTabMenu = menu ? menu.children.find((item) => item.link === currentPath) || menu : {};
    },

    // Actions
    addData() {
      this.isAdd = true;
      this.modalTitle = "Add Role Competency";
      this.resetAddForm();
      this.$bvModal.show("modal-role-competency");
    },

    viewData(data) {
      this.isAdd = null; // View mode
      this.modalTitle = "View Role Competency";
      this.viewDetailData = { ...data };
      this.$bvModal.show("modal-role-competency");
    },

    updateData(data) {
      this.isAdd = false;
      this.modalTitle = "Edit Role Competency";
      this.bodyUpdate.id = data.id;
      this.bodyUpdate.role_competency_id = data.role_competency_id;
      this.bodyUpdate.role_competency_name = data.role_competency_name;
      this.bodyUpdate.role_competency_type = data.role_competency_type;
      this.$bvModal.show("modal-role-competency");
    },

    resetAddForm() {
      this.bodyAdd = {
        role_competency_id: "",
        role_competency_name: "",
        role_competency_type: ""
      };
      this.$validator.reset();
    },

    // Save methods
    saveAdd() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return false;
        
        try {
          await this.$store.dispatch("roleCompetency/createRoleCompetency", this.bodyAdd);
          this.$swal({
            title: "Success",
            text: "Role competency berhasil ditambahkan",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getRoleCompetencies();
            this.$bvModal.hide("modal-role-competency");
            this.resetAddForm();
          });
        } catch (error) {
          console.log("Error response:", error);
          let errorMessage = "Error while adding role competency";
          
          // Handle API error response
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.httpCode === 400 && errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.httpMessage) {
              errorMessage = errorData.httpMessage;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        }
      });
    },

    saveUpdate() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return false;
        
        try {
          await this.$store.dispatch("roleCompetency/updateRoleCompetency", {
            id: this.bodyUpdate.id,
            data: {
              role_competency_id: this.bodyUpdate.role_competency_id,
              role_competency_name: this.bodyUpdate.role_competency_name,
              role_competency_type: this.bodyUpdate.role_competency_type
            }
          });
          this.$swal({
            title: "Success",
            text: "Role competency berhasil diperbarui",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getRoleCompetencies();
            this.$bvModal.hide("modal-role-competency");
          });
        } catch (error) {
          console.log("Error response:", error);
          let errorMessage = "Error while updating role competency";
          
          // Handle API error response
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.httpCode === 400 && errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.httpMessage) {
              errorMessage = errorData.httpMessage;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        }
      });
    },

    deleteData(id) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Tindakan ini tidak dapat dibatalkan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$store.dispatch("roleCompetency/deleteRoleCompetency", id);
            this.getRoleCompetencies();
            this.$swal("Terhapus", "Role competency telah dihapus", "success");
          } catch (error) {
            this.$swal("Error", "Gagal menghapus role competency", "error");
          }
        }
      });
    },

    // API calls
    getRoleCompetencies() {
      this.$store.dispatch("roleCompetency/getRoleCompetencies", this.body);
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getRoleCompetencies();
    }
  }
};
</script>

<style scoped>
.me-2 {
  margin-right: 0.5rem;
}
</style>
